import { getView, requireAuth } from '@/lib/utils';
import { MaterialsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/materials',
  component: getView('pages/PageMaterials'),
  name: 'materials',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Materials',
    leftMenu: Left.MaterialsList,
    roles: ['operator'],
    information: MaterialsPage,
    showBottomMenu: true,
  },
};
